import React from 'react';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import compose from 'lodash/flowRight';
import get from 'lodash/get';

import FeedbackIncreaseLimits from './FeedbackIncreaseLimits';
import { askForeignLimit } from '../../redux/modules/feedbackIncreaseLimits';
import { hideMessageModal, openMessageModal } from '../../redux/modules/messageModal';

import validate from './validate';

const selector = formValueSelector('feedbackIncreaseLimits');

const mapStateToProps = state => ({
  fields: {
    name: selector(state, 'name'),
    phone_number: selector(state, 'phone_number'),
    email: selector(state, 'email'),
    message: selector(state, 'message')
  },
  initialValues: {
    name: get(state, 'userAuthentication.data.display_name', ''),
    email: get(state, 'userAuthentication.data.email', '')
  },
  userToken: get(state, 'userAuthentication.data.access_token'),
  translate: getLang(state.lang, 'static'),
  locale: state.lang.locale,
  isMobile: state.windowDimentions.isMobile,
  userData: get(state, 'userAuthentication.data'),
  isMessageModalOpen: state.messageModal.isMessageModalOpen,
  foreignLimit: state.foreignLimit
});

export default compose(
  connect(mapStateToProps, {
    askForeignLimit,
    hideMessageModal,
    openMessageModal
  }),
  reduxForm({
    form: 'feedbackIncreaseLimits',
    validate
  })
)(FeedbackIncreaseLimits);
